// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '3.11.1'
export const publishDates = {
	major: '2024-09-13T14:36:29.063Z',
	minor: '2025-03-20T14:45:59.625Z',
	patch: '2025-04-03T10:34:39.217Z',
}
